import React, {useState,useEffect} from 'react'
import {envAwarePost,capitalize} from '../../util/util'
import useAccountTypeName from '../../hooks/useAccountTypeName'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import ProfileImageDefault from '../ProfileImageDefault/ProfileImageDefault'
import SectionHeading from '../sectionHeading/SectionHeading'
import { useSelector } from 'react-redux'

//Sub component for accounts
const Account = ({user_name,profile_pic,user_email})=>(
	<tr>
		<td>
			<div className="d-flex">
				<ProfileImageDefault src={profile_pic} alt={user_name}/>
				<div className="w-100">
					<div>
						<strong>{user_name}</strong>
					</div>
					<div>
						{user_email}
					</div>
				</div>
			</div>
		</td>
	</tr>
)
/**
 * Fetches & displays Lists of accounts
 */
const AccountList = ({type})=>{
	const [status,setStatus] = useState('loading')
	const [accounts, setAccounts] = useState([])
	const user = useSelector(state => state.users.current_user.isMAXUser)
	const resolvedAccountType = useAccountTypeName(type)
	useEffect(()=>{
		setStatus('loading')
		const action = {
			client:'getAllClients',
			trainer:'getAllTrainers',
			gym:'getAllGyms'
		}[type]
		console.log(user)
		if (user) {
			const action = {
				client:'getAllMembers',
				trainer:'getAllTrainers',
				gym:'getAllCenters'
			}[type]
		}
		console.log(action)
		envAwarePost('/api/users/api/',{action,include_inactive_in_username:1}).then(res=>{
			setStatus('idle')
			const {success,data} = res
			if(success === '1') setAccounts(data)
		})
	},[type])
	return (
		<div className="p-3">
			<SectionHeading icon="fa fa-users">
				All {capitalize(resolvedAccountType)}s
			</SectionHeading>
			{
				status === 'loading' ?
				<div className="text-center p-5">
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner>
				</div>
				:
				<div style={{maxWidth:'960px',margin:'32px auto'}}>
					<small>Total: {accounts.length}</small>
					<Table size="sm" striped bordered>
						<tbody>
							{accounts.map( account=><Account {...account}/> )}
						</tbody>
					</Table>
				</div>
			}
		</div>
	)
}

export default AccountList